// @flow

import React from 'react';
import styled from 'styled-components';
import { i18n } from 'shared/utils';
import { fonts, colors } from 'shared/styleguide';
import Divider from 'shared/components/common/Divider';
import CustomPieChart from 'shared/components/common/CustomPieChart';

type Props = {
  machineDowntimes: {
    id: string,
    name: string,
    percentage: number,
  }[],
};

const Header = styled.div`
  ${fonts.bodyBold};
  color: ${colors.charcoalGrey};
`;

export default ({ machineDowntimes }: Props) => {
  const data = machineDowntimes.length
    ? machineDowntimes.map(machineDowntime => ({
        id: machineDowntime.id,
        name: machineDowntime.name,
        value: machineDowntime.percentage,
      }))
    : [
        {
          id: 'no-data-downtime',
          name: i18n.t('No Data Available for the Selected Dates'),
          value: 1,
        },
      ];

  return (
    <>
      <Header>{i18n.t(`Downtime (%)`)}</Header>
      <Divider style={{ marginTop: 8 }} />
      <CustomPieChart data={data} />
    </>
  );
};
